<template>
  <image-cell :content="url" :attribute="attribute"></image-cell>
</template>

<script lang="babel">
import ImageCell from '@/components/table/ImageCell.vue';

export default {
  components: {
    ImageCell
  },
  props: ['content', 'attribute'],
  computed: {
    url: function() {
      return `/api/v1/gift/${this.content}`;
    }
  }
};
</script>
